<script setup lang="ts">
import {useMediaStore} from "~/stores/media"
import type {MediaPageData} from '~/types/media/MediaPageData'
import {stripHtml} from "string-strip-html"
import {
  userIsAnonymousStudentOnStudentPage as userIsAnonymousStudent,
  useStudentPageLayout as layout,
} from '~/composables/useStudentPageLayout'
import {useDomainDataStore} from '~/stores/domain'

const { $i18n } = useNuxtApp()
const route = useRoute()
const domainStore = useDomainDataStore()

const media: MediaPageData = useMediaStore().currentMedia as MediaPageData

const canonical = computed(() => domainStore.wwwBaseUrl + route.path)

definePageMeta({
  middleware: ['media-details'/*, 'student-page'*/],
  headerNotSticky: true,
  publicAccess: true,
  layout,
  userIsAnonymousStudent,
})

const metaTitle = () => {
  let s = `${media.title} – ${$i18n.t('meta.title.media')}`
  if (media.baseNodeName) {
    s += ` – ${media.baseNodeName}`
  }

  return s
}
const socialTitle = () => `EduMedia – ${media.title}`
const metaDescription = () => media.description ? stripHtml(media.description).result : null
const metaImage = () => media.thumbnailSizes.node_pack

useHead({
  link: computed(() => [
    { rel: 'canonical', href: canonical.value },
  ]),
})

useSeoMeta({
  title: metaTitle,
  ogTitle: socialTitle,
  twitterTitle: socialTitle,

  description: metaDescription,
  ogDescription:  metaDescription,
  twitterDescription: metaDescription,

  ogImage: metaImage,
  twitterImage: metaImage,
  twitterCard: 'summary_large_image',

  ogUrl: canonical,
})
</script>

<template>
  <LazyMoleculesMediaPageFull v-if="media.full" :media="media" context="media"/>
  <MoleculesMediaPageTeaser v-else :media="media"/>
</template>
